export default "__VITE_ASSET__40d65158__"